__turbopack_context__.v({
  "backBtn": "import-details-module__h_zfFa__backBtn",
  "brandName": "import-details-module__h_zfFa__brandName",
  "brandsCard": "import-details-module__h_zfFa__brandsCard",
  "brandsTable": "import-details-module__h_zfFa__brandsTable",
  "container": "import-details-module__h_zfFa__container",
  "emptyState": "import-details-module__h_zfFa__emptyState",
  "error": "import-details-module__h_zfFa__error",
  "header": "import-details-module__h_zfFa__header",
  "icon": "import-details-module__h_zfFa__icon",
  "loading": "import-details-module__h_zfFa__loading",
  "logoText": "import-details-module__h_zfFa__logoText",
  "noData": "import-details-module__h_zfFa__noData",
  "regNumber": "import-details-module__h_zfFa__regNumber",
  "searchBox": "import-details-module__h_zfFa__searchBox",
  "statCard": "import-details-module__h_zfFa__statCard",
  "statLabel": "import-details-module__h_zfFa__statLabel",
  "statValue": "import-details-module__h_zfFa__statValue",
  "statsBar": "import-details-module__h_zfFa__statsBar",
  "statusBadge": "import-details-module__h_zfFa__statusBadge",
  "subtitle": "import-details-module__h_zfFa__subtitle",
  "tableWrapper": "import-details-module__h_zfFa__tableWrapper",
  "title": "import-details-module__h_zfFa__title",
  "titleRow": "import-details-module__h_zfFa__titleRow",
});
